import { Button, Input, message, Result, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import Camara from '../../../../static/autos/Camara.jpg';
import { errorHandler, heicAndheifConvert, isMobile } from '../../../../utils';
import { instanceRef } from '../../../../utils/axios';

export default function Success(props) {
  const [extraFoto, setExtraFoto] = useState(false);
  const [imagen, setImagen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [newKey, setNewKey] = useState(-1);
  const [text, setText] = useState();
  const [havename, setHavename] = useState(false);
  const { uploadFile, updateInspeccion } = useInspeccionContext();
  const { inspeccion } = props;

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async () => {
    setLoading(true);
    const responseArchivos = await instanceRef.instance.get(`/archivos/`, {
      params: {
        filter: {
          token: inspeccion.token,
          type: 'i',
          url: true,
          marked: false,
          base64: false,
          imgcompress: true
        }
      }
    });
    setLoading(false);
    const keys = [];
    const fotos = responseArchivos.data.data;
    fotos.forEach((element) => {
      keys.push(element.paso_nro);
    });
    const min = Math.min(...keys) - 1;
    setNewKey(min);
  };

  const card = [
    {
      item: `${newKey}`,
      key: newKey,
      parte: text,
      image: Camara,
      check: false
    }
  ];

  const saveimage = async (file) => {
    if (havename) {
      try {
        if (isMobile) {
          setLoading(true);
          await uploadFile(file, newKey, inspeccion, text);
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagen(reader.result);
            setDisabled(false);
          };
          await updateInspeccion('FOTOS_SUBIDAS');
          setLoading(false);
          reader.readAsDataURL(file);
        } else {
          errorHandler(null, 'Debe tomar la foto desde un dispositivo móvil');
        }
      } catch (err) {
        // error
      }
    } else {
      message.info('Debe completar el nombre de la foto');
    }
  };

  const customRequest = async ({ file }) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };

  const savename = async (newtext) => {
    if (newtext.trim() === '') {
      setHavename(false);
      message.info('Debe asignar nombre a la imagen');
    } else {
      setText(newtext);
      setHavename(true);
    }
  };

  return (
    <div>
      {(extraFoto && (
        <>
          <Input
            placeholder="Parte del vehículo"
            style={{ width: 'auto', marginLeft: 6 }}
            onBlur={(e) => {
              savename(e.target.value);
            }}
            autoFocus
          />
          <BoxImage
            customRequest={customRequest}
            imagen={imagen || Camara}
            loading={loading}
            card={card}
            disabled={!havename}
          />
          <Space>
            <Button onClick={() => window.location.reload(false)}>
              Anterior
            </Button>
            <Button
              type="primary"
              disabled={disabled}
              onClick={() => window.location.reload(false)}
            >
              Finalizar
            </Button>
          </Space>{' '}
        </>
      )) || (
        <Result
          status="success"
          title="¡Inspección finalizada!"
          subTitle="Sujeta a verificación"
          extra={[
            <Button
              type="primary"
              key="salir"
              onClick={() => {
                window.location.href = '/';
              }}
              style={{
                marginLeft: 4,
                marginRight: 4,
                marginBottom: 8
              }}
            >
              Ir al inicio
            </Button>,
            <Button
              type="primary"
              ghost
              key="subir"
              onClick={() => {
                setExtraFoto(true);
              }}
            >
              Subir más fotos
            </Button>
          ]}
        />
      )}
    </div>
  );
}
